module.exports = __webpack_public_path__ + "media/images/pay1-color-872f5fdb4e9bd26559f06734254d3cd5.svg";